<template>
  <div :style="cssVars" class="app-wrapper">
    <router-view v-if="token" @openArticle="openArticle" />
    <FooterBlock v-if="token" @modal="showCallback = true" />
    <CallbackModal
      v-if="token"
      :show="showCallback"
      @modal="showCallback = false"
    />
    <ArticleModal
      v-if="token"
      :show="showArticle"
      @modal="showArticle = false"
      :articleId="articleId"
      @openArticle="
        (id) => {
          openArticle(id);
        }
      "
    />
    <UnloginedModal v-if="showUnloginedModal" />
  </div>
</template>

<script>
import FooterBlock from '@/components/blocks/footer/FooterBlock.vue';
import CallbackModal from '@/components/modal/CallbackModal.vue';
import UnloginedModal from '@/components/modal/UnloginedModal.vue';
import ArticleModal from '@/components/modal/ArticleModal.vue';
import { auth, reAuth } from '@/functions/API';
import { getToken } from '@/functions/token';
// import { showPopup } from '@/functions/popup';

const DEV_MODE = process.env.NODE_ENV === 'development';
const DEV_PHONE = process.env.VUE_APP_DEV_PHONE;
const DEV_USERID = process.env.VUE_APP_DEV_USERID;

export default {
  name: 'HomeView',
  components: {
    FooterBlock,
    CallbackModal,
    ArticleModal,
    UnloginedModal,
  },
  data() {
    return {
      showCallback: false,
      showArticle: false,
      showUnloginedModal: false,
      articleId: null,
      cssVars: {},
      token: null,
    };
  },
  mounted() {
    this.selectTheme();
    window.WebApp.onEvent('WebAppBackButtonPressed', () => {
      if (this.showCallback) {
        this.showCallback = false;
        return;
      }
      if (this.showArticle) {
        this.showArticle = false;
        return;
      }
      if (!this.showCallback && !this.showArticle) {
        if (this.$route.name == 'home') {
          window.WebApp.close();
        } else {
          this.$router.back();
        }
      }
    });
    getToken((token) => {
      if (token === null || token === 'null') {
        this.login();
      } else {
        this.token = token;
      }
    });
  },
  watch: {
    $route() {
      if (this.$route.name == 'home') {
        if (window?.WebApp) {
          window.WebApp.BackButton.hide();
        }
      } else {
        if (window?.WebApp?.BackButton) {
          window.WebApp.BackButton.show();
        }
      }
    },
    showCallback() {
      if (this.showCallback) {
        if (window?.WebApp) {
          window.WebApp.BackButton.show();
        }
        const body = document.getElementsByTagName('body')[0];
        if (body) {
          body.classList.add('fix');
        }
      } else {
        if (window?.WebApp) {
          if (this.$route.name == 'home') {
            window.WebApp.BackButton.hide();
          } else {
            window.WebApp.BackButton.show();
          }
        }
        const body = document.getElementsByTagName('body')[0];
        if (body) {
          body.classList.remove('fix');
        }
      }
    },
    showArticle() {
      if (this.showArticle) {
        if (window?.WebApp) {
          window.WebApp.BackButton.show();
        }
        const body = document.getElementsByTagName('body')[0];
        if (body) {
          body.classList.add('fix');
        }
      } else {
        if (this.$route.name == 'home') {
          window.WebApp.BackButton.hide();
        } else {
          window.WebApp.BackButton.show();
        }
        const body = document.getElementsByTagName('body')[0];
        if (body) {
          body.classList.remove('fix');
        }
      }
    },
  },
  methods: {
    login() {
      var userId;
      const t = this;
      if (DEV_MODE) {
        userId = DEV_USERID;
      } else {
        userId = window?.WebApp?.initDataUnsafe?.user?.id;
      }
      if (userId) {
        reAuth(userId, (res) => {
          if (res !== false) {
            t.token = res;
          } else {
            if (DEV_MODE) {
              auth(DEV_PHONE, userId, (res) => {
                if (res !== false) {
                  t.token = res;
                } else {
                  t.showUnloginedModal = true;
                }
              });
            } else {
              window.WebApp.requestContact().then(function (res) {
                let reqPhone = '';
                const phone = res?.phone;
                const userId = window?.WebApp?.initDataUnsafe?.user?.id;
                if (phone.length > 10) {
                  reqPhone = phone.slice(-10);
                }
                if (reqPhone.length > 0) {
                  auth(reqPhone, userId, (res) => {
                    if (res !== false) {
                      t.token = res;
                    } else {
                      t.showUnloginedModal = true;
                    }
                  });
                }
              });
            }
          }
        });
      } else {
        if (window?.WebApp) {
          window.WebApp.close();
        }
      }
    },
    openArticle(id) {
      this.showArticle = true;
      this.articleId = id;
    },
    selectTheme() {
      const templateLight = {
        '--color-white': '#ffffff',
        '--color-white-opacity': '#fffffff0',
        '--color-light': '#f5f5f5',
        '--color-black': '#1F1F1F',
        '--color-black-opacity': '#1F1F1Fb0',
        '--color-gray': '#7a7a7a',
        '--color-gray-light': '#f5f5f5',
        '--color-gray-middle': '#d6d6d6',
        '--color-blue': '#1664da',
        '--color-blue-active': '#0088ff',
        '--color-critical': '#D13F4B',
      };
      const templateDark = {
        '--color-white': '#161616',
        '--color-white-opacity': '#161616f0',
        '--color-light': '#262626',
        '--color-black': '#dddddd',
        '--color-black-opacity': '#ddddddb0',
        '--color-gray': '#999999',
        '--color-gray-light': '#262626',
        '--color-gray-middle': '#888888',
        '--color-blue': '#1664da',
        '--color-blue-active': '#0088ff',
        '--color-critical': '#D13F4B',
      };
      this.cssVars =
        window.WebApp.colorScheme == 'dark' ? templateDark : templateLight;
    },
  },
};
</script>

<style lang="scss" scoped>
.app-wrapper {
  width: 100%;
  background-color: var(--color-white);
  color: var(--color-black);
  overflow: hidden;
  padding-top: 12px;
  padding-bottom: 80px;
  overflow-y: auto;
}
</style>
